import { useState } from "react";
import { Plus, Minus } from "lucide-react";

export default function FAQAccordion({ items = [], title = "Common Questions" }) {
  const [open, setOpen] = useState(0);
  if (!items?.length) return null;

  return (
    <section className="section bg-bone" data-testid="faq-section">
      <div className="max-w-4xl mx-auto">
        <div className="mb-12 md:mb-16">
          <div className="overline mb-3">FAQs</div>
          <h2 className="text-3xl md:text-5xl font-display font-bold text-forest tracking-tight mb-4 text-balance">
            {title}
          </h2>
          <p className="text-base md:text-lg text-charcoal-soft leading-relaxed">
            Honest answers to the questions Ohio accident victims ask us most.
          </p>
        </div>

        <div className="border-t border-black/5">
          {items.map((f, idx) => {
            const isOpen = open === idx;
            return (
              <div key={f.id} className="border-b border-black/5" data-testid={`faq-item-${idx}`}>
                <button
                  onClick={() => setOpen(isOpen ? -1 : idx)}
                  className="w-full text-left py-5 md:py-6 flex items-start justify-between gap-6 group"
                  data-testid={`faq-toggle-${idx}`}
                >
                  <span className="font-display font-bold text-base md:text-xl text-forest leading-tight flex-1 group-hover:text-terracotta transition-colors">
                    {f.question}
                  </span>
                  <span className={`shrink-0 w-9 h-9 rounded-full grid place-items-center transition-all ${isOpen ? "bg-terracotta text-white rotate-90" : "bg-forest/5 text-forest"}`}>
                    {isOpen ? <Minus className="w-4 h-4" /> : <Plus className="w-4 h-4" />}
                  </span>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${isOpen ? "max-h-96 pb-6" : "max-h-0"}`}
                >
                  <p className="text-charcoal-soft text-base md:text-lg leading-relaxed">{f.answer}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
